module.exports = __webpack_public_path__ + "img/open-book.c2b42dd0.png";